import { PostAPI } from 'Components/Helper/Helpers';


export const TerminalRegister = async (request) => {
    return PostAPI(request, 'NSDLBankAEPS/TerminalRegister');
};

export const Authentication = async (request) => {
    return PostAPI(request, 'NSDLBankAEPS/TwoFaAuthLogin');
};

export const CashWithdrawal = async (request) => {
    return PostAPI(request, 'NSDLBankAEPS/CashWithdrawal');
};

export const BalanceEnquiry = async (request) => {
    return PostAPI(request, 'NSDLBankAEPS/BalanceEnquiry');
};

export const MiniStatement = async (request) => {
    return PostAPI(request, 'NSDLBankAEPS/MiniStatement');
};